module.exports = __webpack_public_path__ + "img/index_sj.b343356b.svg";